/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as AdminLlmRouteImport } from './routes/admin.llm'
import { Route as AdminStyleRouteImport } from './routes/admin.style'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as ClientsIndexRouteImport } from './routes/clients.index'
import { Route as ClientsClientIdRouteImport } from './routes/clients.$clientId'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects.$projectId'
import { Route as ProjectsCreateRouteImport } from './routes/projects.create'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveRoute = ArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLlmRoute = AdminLlmRouteImport.update({
  id: '/admin/llm',
  path: '/admin/llm',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStyleRoute = AdminStyleRouteImport.update({
  id: '/admin/style',
  path: '/admin/style',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientsRoute,
} as any)
const ClientsClientIdRoute = ClientsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => ClientsRoute,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => ProjectsRoute,
} as any)
const ProjectsCreateRoute = ProjectsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => ProjectsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/archive': typeof ArchiveRoute
  '/clients': typeof ClientsRouteWithChildren
  '/login': typeof LoginRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/admin/llm': typeof AdminLlmRoute
  '/admin/style': typeof AdminStyleRoute
  '/admin/users': typeof AdminUsersRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/clients/': typeof ClientsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/archive': typeof ArchiveRoute
  '/login': typeof LoginRoute
  '/admin/llm': typeof AdminLlmRoute
  '/admin/style': typeof AdminStyleRoute
  '/admin/users': typeof AdminUsersRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/clients': typeof ClientsIndexRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/analytics': typeof AnalyticsRoute
  '/archive': typeof ArchiveRoute
  '/clients': typeof ClientsRouteWithChildren
  '/login': typeof LoginRoute
  '/projects': typeof ProjectsRouteWithChildren
  '/admin/llm': typeof AdminLlmRoute
  '/admin/style': typeof AdminStyleRoute
  '/admin/users': typeof AdminUsersRoute
  '/clients/$clientId': typeof ClientsClientIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/create': typeof ProjectsCreateRoute
  '/clients/': typeof ClientsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/analytics'
    | '/archive'
    | '/clients'
    | '/login'
    | '/projects'
    | '/admin/llm'
    | '/admin/style'
    | '/admin/users'
    | '/clients/$clientId'
    | '/projects/$projectId'
    | '/projects/create'
    | '/clients/'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/analytics'
    | '/archive'
    | '/login'
    | '/admin/llm'
    | '/admin/style'
    | '/admin/users'
    | '/clients/$clientId'
    | '/projects/$projectId'
    | '/projects/create'
    | '/clients'
    | '/projects'
  id:
    | '__root__'
    | '/'
    | '/analytics'
    | '/archive'
    | '/clients'
    | '/login'
    | '/projects'
    | '/admin/llm'
    | '/admin/style'
    | '/admin/users'
    | '/clients/$clientId'
    | '/projects/$projectId'
    | '/projects/create'
    | '/clients/'
    | '/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AnalyticsRoute: typeof AnalyticsRoute
  ArchiveRoute: typeof ArchiveRoute
  ClientsRoute: typeof ClientsRouteWithChildren
  LoginRoute: typeof LoginRoute
  ProjectsRoute: typeof ProjectsRouteWithChildren
  AdminLlmRoute: typeof AdminLlmRoute
  AdminStyleRoute: typeof AdminStyleRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive': {
      id: '/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof ArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/llm': {
      id: '/admin/llm'
      path: '/admin/llm'
      fullPath: '/admin/llm'
      preLoaderRoute: typeof AdminLlmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/style': {
      id: '/admin/style'
      path: '/admin/style'
      fullPath: '/admin/style'
      preLoaderRoute: typeof AdminStyleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof ClientsRoute
    }
    '/clients/$clientId': {
      id: '/clients/$clientId'
      path: '/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof ClientsClientIdRouteImport
      parentRoute: typeof ClientsRoute
    }
    '/projects/': {
      id: '/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof ProjectsRoute
    }
    '/projects/create': {
      id: '/projects/create'
      path: '/create'
      fullPath: '/projects/create'
      preLoaderRoute: typeof ProjectsCreateRouteImport
      parentRoute: typeof ProjectsRoute
    }
  }
}

interface ClientsRouteChildren {
  ClientsClientIdRoute: typeof ClientsClientIdRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
}

const ClientsRouteChildren: ClientsRouteChildren = {
  ClientsClientIdRoute: ClientsClientIdRoute,
  ClientsIndexRoute: ClientsIndexRoute,
}

const ClientsRouteWithChildren =
  ClientsRoute._addFileChildren(ClientsRouteChildren)

interface ProjectsRouteChildren {
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsCreateRoute: typeof ProjectsCreateRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

const ProjectsRouteChildren: ProjectsRouteChildren = {
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsCreateRoute: ProjectsCreateRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}

const ProjectsRouteWithChildren = ProjectsRoute._addFileChildren(
  ProjectsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnalyticsRoute: AnalyticsRoute,
  ArchiveRoute: ArchiveRoute,
  ClientsRoute: ClientsRouteWithChildren,
  LoginRoute: LoginRoute,
  ProjectsRoute: ProjectsRouteWithChildren,
  AdminLlmRoute: AdminLlmRoute,
  AdminStyleRoute: AdminStyleRoute,
  AdminUsersRoute: AdminUsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
